import React from 'react';
import { Key } from 'lucide-react';

const AccessKeyManager = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Gerenciar Chaves de Acesso
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Administre as chaves de acesso do sistema
          </p>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 p-8">
        <div className="text-center py-12">
          <Key className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            Gerenciamento de Chaves
          </h3>
          <p className="text-gray-500 dark:text-gray-400">
            Esta funcionalidade será implementada em breve
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessKeyManager;